import { CREATE_ACCOUNTS, UPDATE_ACCOUNTS, CHANGE_THRESHOLD, CLEAR, GET_RETESTS, GET_RETEST_REASONS } from './mutation-types'
import moment from 'moment-timezone'

export default {
  [CREATE_ACCOUNTS] (state) {
    state.latestUpdate = moment().toISOString()
  },

  [UPDATE_ACCOUNTS] (state) {
    state.latestUpdate = moment().toISOString()
  },

  [CHANGE_THRESHOLD] (state, { days }) {
    state.recentAccountsThreshold = days
  },

  [CLEAR] (state) {
    state.latestUpdate = 0
  },
  [GET_RETESTS] (state, retestData) {
    state.retests[retestData.assessmentId] = retestData.retests
  },
  [GET_RETEST_REASONS] (state, reasons) {
    state.retestReasons = reasons
  }
}
